__turbopack_context__.v({
  "block": "continue-reading-module__KLn6ja__block",
  "chapter": "continue-reading-module__KLn6ja__chapter",
  "text": "continue-reading-module__KLn6ja__text",
  "title": "continue-reading-module__KLn6ja__title",
});
